import { render, staticRenderFns } from "./LbIp.vue?vue&type=template&id=12249fb3&"
import script from "./LbIp.vue?vue&type=script&lang=js&"
export * from "./LbIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports